import moment from 'moment';
export const STATUS = {
    ONLINE: 1,
    OFFLINE: 0,
}
const runLocal = process.env.REACT_APP_DEV_API === "false";
const development = process.env.NODE_ENV === "development";
const production = (process.env.NODE_ENV === "production" || process.env.REACT_APP_PROD === "true") && process.env.REACT_APP_DEV_API === "false";
export const SOCIAL_KEY = process.env.REACT_APP_SOCIAL_KEY;
export const API_URL = development ? (runLocal ? `http://localhost:8001` : `https://api.thebeautrium.com`) : `/ssr`;
export const ROOT_URL = development ? `http://localhost:8001` : (runLocal ? `http://localhost:8001` : `https://api.thebeautrium.com`);
export const PUBLIC_URL = 'https://thebeautrium.com';
export const STRAPI_API = development ? `http://localhost:1337` : `https://cms.thebeautrium.com`;
export const PAYMENT_VERSION = "NEW";
export const PROMPTPAY = "0868885840";
export const KBANK_API = (process.env.NODE_ENV === "development" && process.env.REACT_APP_PROD !== "true") ? "https://dev-kpaymentgateway-services.kasikornbank.com" : "https://kpaymentgateway-services.kasikornbank.com";
export const KBANK_PUBLIC_KEY = process.env.REACT_APP_KBANK_PUBLIC_KEY;
export const IP = production ? `https://api.thebeautrium.com` : (runLocal ? `http://localhost:8001` : `https://api.thebeautrium.com`);
export const BEAUTRIUM_INTRO = "BEAUTRIUM is the most leading beauty multi brand store."
export const DELIVERY_COST = 55;
export const DELIVERY_THRESHOLD = moment().isSameOrAfter('2025-04-02', 'd') ? 499 : 699;